import { clone, isEmpty, isNil } from "ramda";

import { getMuiTheme, verifyRequestError } from "../../../utils/utils";
import {
  deleteAlert,
  getAllAlertsData,
  postReport,
  postReportDocumentMulti,
  postReportDocumentOne,
  putAlert,
} from "../../../api";
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import palette from "../../../../config/colorPalette";
import { ThemeProvider } from "@mui/material/styles";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PhotoIcon from "@mui/icons-material/Photo";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import FolderZipIcon from "@mui/icons-material/FolderZip";

export const loadAlerts = async ({ assetName, setAlerts, setLoading, dispatch, navigate, archived, intl }) => {
  setLoading(true);
  try {
    const response = await getAllAlertsData(archived);
    if (!isNil(response?.status) && response?.status === 200 && !isNil(response.data)) {
      const alerts = response.data.data;
      //alerts.sort((a, b) => {
      //  if (!isNil(assetName) && a.asset === assetName && b.asset !== assetName) {
      //    return -1;
      //  } else if (!isNil(assetName) && a.asset !== assetName && b.asset === assetName) {
      //    return 1;
      //  } else {
      //    const dA = new Date(a.dateStart);
      //    const dB = new Date(b.dateStart);
      //    return dB - dA;
      //  }
      //});
      await setAlerts(alerts);
      if (isNil(alerts) || isEmpty(alerts)) {
        setLoading(false);
      }
    }
  } catch (error) {
    verifyRequestError({ error, dispatch, navigate, intl });
  }
  if (!isNil(archived)) {
    setLoading(false);
  }
};

export const getColumnsMeasurement = (intl) => {
  const columns = [
    { field: "id", headerName: "Id", hide: true, disableExport: true },
    { field: "asset", headerName: intl.formatMessage({ id: "structure" }), flex: 1 },
    { field: "equipmentID", headerName: intl.formatMessage({ id: "equipment" }), flex: 1.4 },
    { field: "substructure", headerName: intl.formatMessage({ id: "sub" }), flex: 1.4 },
    { field: "package", headerName: intl.formatMessage({ id: "measurand" }), flex: 1.2 },
    {
      field: "customValue",
      headerName: intl.formatMessage({ id: "registered value" }),
      flex: 1.2,
      disableExport: true,
    },
    { field: "dateStart", headerName: intl.formatMessage({ id: "start.date" }), flex: 1.5 },
    { field: "dateEnd", headerName: intl.formatMessage({ id: "end.date" }), flex: 1.5 },
    { field: "coordinates", headerName: intl.formatMessage({ id: "coordinates" }), flex: 2 },
    { field: "startPoint", headerName: intl.formatMessage({ id: "start point" }), flex: 1 },
    { field: "endPoint", headerName: intl.formatMessage({ id: "end point" }), flex: 1 },
    {
      field: "actions",
      type: "actions",
      headerName: intl.formatMessage({ id: "actions" }),
      width: 150, // Set a fixed width for action buttons
      cellClassName: "actions",
      getActions: null,
      disableExport: true,
    },
  ];
  return columns;
};
export const getColumnsEquipment = (intl) => {
  const columns = [
    { field: "id", headerName: "Id", hide: true, disableExport: true },
    { field: "asset", headerName: intl.formatMessage({ id: "structure" }), flex: 1.5 },
    {
      field: "equipment",
      headerName: intl.formatMessage({ id: "equipment" }),
      flex: 1.2,
      disableExport: true,
    },
    {
      field: "customValue",
      headerName: intl.formatMessage({ id: "registered value" }),
      flex: 1,
      disableExport: true,
    },
    { field: "dateStart", headerName: intl.formatMessage({ id: "date" }), flex: 1.5 },
    { field: "dateEnd", headerName: intl.formatMessage({ id: "end.date" }), flex: 1.5 },
    { field: "description", headerName: intl.formatMessage({ id: "description" }), flex: 2 },
    {
      field: "actions",
      type: "actions",
      headerName: intl.formatMessage({ id: "actions" }),
      width: 100,
      cellClassName: "actions",
      getActions: null,
      disableExport: true,
    },
  ];
  return columns;
};

export const handleDeleteAlert = async ({
  id,
  alerts,
  deleteType,
  setAlerts,
  setDisplayAlerts,
  setLoading,
  setOpenTextModal,
  dispatch,
  navigate,
  intl,
}) => {
  if (isNil(id)) {
    // delete all
    if (!isNil(alerts)) {
      try {
        await alerts.forEach(async (item) => {
          await deleteAlert(item.id, deleteType);
        });
        loadAlerts({ setAlerts, setLoading, dispatch, navigate, intl });
        setOpenTextModal(false);
      } catch (error) {
        throw Error("The alert was not deleted");
      }
    }
    return;
  }
  try {
    const response = await deleteAlert(id, deleteType);
    if (!isNil(response)) {
      loadAlerts({ setAlerts, setLoading, dispatch, navigate, intl });
      setOpenTextModal(false);
    }
  } catch (error) {
    verifyRequestError({ error, dispatch, navigate, intl });
  }
  const updatedDisplayAlerts = alerts.filter((ua) => ua.id !== id);
  setDisplayAlerts(updatedDisplayAlerts);
};

export const putAlarms = async ({ id, alerts, allAlerts, setAlerts, displayAlerts, setDisplayAlerts, type, intl }) => {
  let toSendAlert = displayAlerts.find((item) => item.id === id);
  if (toSendAlert.isArchived) {
    toSendAlert.isArchived = false;
  } else {
    toSendAlert.isArchived = true;
  }
  await putAlert(id, toSendAlert, type, intl);

  const updatedDisplayAlerts = displayAlerts.map((alert) =>
    alert.id === id ? { ...alert, isArchived: toSendAlert.isArchived } : alert,
  );
  setDisplayAlerts(updatedDisplayAlerts);

  if (setAlerts) {
    const updatedAlerts = alerts.map((alert) =>
      alert.id === id ? { ...alert, isArchived: toSendAlert.isArchived } : alert,
    );
    let newAlert = clone(allAlerts);
    newAlert[`${type}s`] = updatedAlerts;
    setAlerts(newAlert);
  }
};

const IconDisplay = ({ file, fileIndex }) => {
  const parts = file.type.split("/");
  const type = parts[0];

  if (type === "image") {
    return <PhotoIcon id={`display_${fileIndex}_${type}`} sx={{ cursor: "pointer", margin: "1%" }} />;
  }
  if (type === "video") {
    return <OndemandVideoIcon id={`display_${fileIndex}_${type}`} sx={{ cursor: "pointer", margin: "1%" }} />;
  }
  if (type === "audio") {
    return <MusicNoteIcon id={`display_${fileIndex}_${type}`} sx={{ cursor: "pointer", margin: "1%" }} />;
  }
  if (type === "compressed") {
    return <FolderZipIcon id={`display_${fileIndex}_${type}`} sx={{ cursor: "pointer", margin: "1%" }} />;
  }
  if (file.name?.endsWith(".pdf")) {
    return <PictureAsPdfIcon id={`display_${fileIndex}_${type}`} sx={{ cursor: "pointer", margin: "1%" }} />;
  } else {
    return <InsertDriveFileIcon id={`display_${fileIndex}_${type}`} sx={{ cursor: "pointer", margin: "1%" }} />;
  }
};
const handleClose = (setOpen, setFileList, setComment) => {
  setOpen(false);
  setFileList([]);
  setComment("");
};
export const AlertReportModal = ({
  alert,
  alerts,
  allAlerts,
  setAlerts,
  displayAlerts,
  setDisplayAlerts,
  type,
  open,
  setOpen,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [comment, setComment] = useState("");
  const [fileList, setFileList] = useState([]);

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} onClose={() => handleClose(setOpen, setFileList, setComment)}>
        <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
          {intl.formatMessage({ id: "report.alert" })}
        </DialogTitle>
        <DialogContent style={{ paddingBottom: "0" }}>
          <div style={{ paddingBottom: "5%" }}>
            <h3>{intl.formatMessage({ id: "alert.info" })}</h3>
            <span>
              <b>{intl.formatMessage({ id: "channel" })}:</b> {alert.channel}
            </span>
            <br />
            {!isNil(alert.eventType) && (
              <>
                <span>
                  <b>{intl.formatMessage({ id: "measurement" })}:</b> {intl.formatMessage({ id: alert.eventType })}
                </span>
                <br />
              </>
            )}
            <span>
              <b>{intl.formatMessage({ id: "date.start" })}:</b> {alert.dateStart}
            </span>
            <br />
            <span>
              <b>{intl.formatMessage({ id: "date.end" })}:</b> {alert.dateEnd}
            </span>
            <br />
            <div style={{ marginTop: "2%" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: alert.status === "false_positive" ? "#47a866" : palette.secondary,
                  marginRight: "1%",
                  color: "white",
                }}
                disabled={alert.status === "false_positive"}
                onClick={async () => {
                  let newAlert = clone(alert);
                  newAlert.status = "false_positive";
                  const response = await putAlert(alert.id, newAlert, "measurement", intl);
                  if (response?.status === 200) {
                    const updatedDisplayAlerts = displayAlerts.map((a) =>
                      a.id === alert.id ? { ...a, status: "false_positive" } : a,
                    );
                    setDisplayAlerts(updatedDisplayAlerts);

                    if (setAlerts) {
                      const updatedAlerts = alerts.map((a) =>
                        a.id === alert.id ? { ...a, status: "false_positive" } : a,
                      );
                      let newAlert = clone(allAlerts);
                      newAlert[`${type}s`] = updatedAlerts;
                      setAlerts(newAlert);
                    }
                  }

                  setOpen(false);
                }}
              >
                {intl.formatMessage({ id: "false.positive" })}
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: alert.status === "not_verified" ? "#47a866" : palette.secondary,
                  marginLeft: "1%",
                  color: "white",
                }}
                disabled={alert.status === "not_verified"}
                onClick={async () => {
                  let newAlert = clone(alert);
                  newAlert.status = "not_verified";
                  const response = await putAlert(alert.id, newAlert, "measurement", intl);
                  if (response?.status === 200) {
                    const updatedDisplayAlerts = displayAlerts.map((a) =>
                      a.id === alert.id ? { ...a, status: "not_verified" } : a,
                    );
                    setDisplayAlerts(updatedDisplayAlerts);

                    if (setAlerts) {
                      const updatedAlerts = alerts.map((a) =>
                        a.id === alert.id ? { ...a, status: "not_verified" } : a,
                      );
                      let newAlert = clone(allAlerts);
                      newAlert[`${type}s`] = updatedAlerts;
                      setAlerts(newAlert);
                    }
                  }
                  setOpen(false);
                }}
              >
                {intl.formatMessage({ id: "not_verified" })}
              </Button>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "16px" }}>
            {/* Columna izquierda: TextField + Upload Button */}
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <TextField
                multiline
                fullWidth
                label={intl.formatMessage({ id: "comment" })}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                value={comment}
              />
              <Button
                variant="contained"
                color="primary"
                component="label"
                style={{ marginTop: "8px", alignSelf: "flex-start" }}
              >
                {intl.formatMessage({ id: "upload.file" })}
                <input
                  type="file"
                  hidden
                  multiple
                  onChange={(e) => {
                    const files = e.target.files;
                    setFileList((newFiles) => [...newFiles, ...files]);
                  }}
                />
              </Button>
            </div>

            {/* Columna derecha: Chips */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px" }}>
              {fileList &&
                fileList.map((file, fileIndex) => (
                  <Chip
                    key={`${file.name}_${fileIndex}`}
                    label={
                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        {file.name}
                        <IconDisplay file={file} fileIndex={fileIndex} />
                      </span>
                    }
                    onDelete={() => {
                      let newFiles = clone(fileList);
                      newFiles.splice(fileIndex, 1);
                      setFileList(newFiles);
                    }}
                  />
                ))}
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            style={{ backgroundColor: palette.secondary, color: "white" }}
            onClick={() => handleClose(setOpen, setFileList, setComment)}
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>

          <Button
            variant="contained"
            style={{ backgroundColor: comment === "" ? palette.light : palette.primary, color: "white" }}
            disabled={comment === ""}
            onClick={async () => {
              const commentResult = await postReport({ content: comment, alertId: alert.id }, intl);
              console.log(commentResult);
              const reportId = commentResult.data.data.id;
              if (!isNil(fileList) && !isEmpty(fileList) && fileList.length > 1) {
                const commentFileResult = await postReportDocumentMulti(reportId, fileList, intl);
                console.log(commentFileResult);
              } else if (!isNil(fileList) && !isEmpty(fileList)) {
                const commentFileResult = await postReportDocumentOne(reportId, fileList[0], intl);
                console.log(commentFileResult);
              }
              handleClose(setOpen, setFileList, setComment);
            }}
          >
            {intl.formatMessage({ id: "accept" })}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
